<template>

  <a-drawer width="800" placement="right"
            :closable="false"
            :visible="visible"
            @close="() => { $emit('onClose') }">
    <template v-if="invoice">
      <p :style="[pStyle, pStyle2]">发票详情</p>
      <p :style="pStyle">基本信息</p>
      <a-row>
        <a-col :span="24">
          <description-item title="开票金额">
            <template slot="content">
              {{ invoice.totalAmount / 100 }} 元
            </template>
          </description-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <description-item title="申请状态">
            <template slot="content">
                <a-tag v-if="invoice.state === 1 || invoice.state === 3" color="#87d068">
                  {{ invoice.state?invoiceStates[invoice.state].name:'' }}
                </a-tag>
                <a-tag v-else-if="invoice.state === 2" color="#108ee9">
                  {{ invoice.state?invoiceStates[invoice.state].name:'' }}
                </a-tag>
                <a-tag v-else-if="invoice.state === 4" color="red">
                  {{ invoice.state?invoiceStates[invoice.state].name:'' }}
                </a-tag>
                <a-tag v-else color="#f50">
                  {{ invoice.state?invoiceStates[invoice.state].name:'' }}
                </a-tag>
            </template>
          </description-item>
        </a-col>
        <a-col :span="12">
          <description-item title="发票类型">
            <template slot="content">
              <a-tag :color="invoice.invoiceType && invoice.invoiceType===1?'#87d068':'#108ee9'">
                {{ invoice.invoiceType?invoiceTypes[invoice.invoiceType].name:'' }}
              </a-tag>
            </template>
          </description-item>
        </a-col>
      </a-row>
      <a-divider/>
      <p :style="pStyle">抬头详情</p>
      <a-row>
        <a-col :span="12">
          <description-item title="名称" :content="invoice.buyerName"/>
        </a-col>
        <a-col :span="12">
          <description-item title="类型">
            <template slot="content">
              <a-tag :color="invoice.buyerType && invoice.buyerType===1?'#3b5999':'#55acee'">
                {{ invoice.buyerType?buyerTypes[invoice.buyerType].name :'' }}
              </a-tag>
            </template>
          </description-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" v-if="invoice.buyerType === 1">
          <description-item title="纳税人识别号" :content="invoice.buyerTaxNumber"/>
        </a-col>
      </a-row>
      <a-divider/>
      <p :style="pStyle">邮寄信息</p>

      <a-row v-if="invoice.email &&invoice.email.length>0">
        <a-col :span="12">
          <description-item title="电子邮箱" :content="invoice.email"/>
        </a-col>
      </a-row>
      <a-divider/>
      <p :style="pStyle">订单信息</p>
      <a-row>
        <a-table :columns="orderColumns" :data-source="invoice.orders" rowKey="no"  bordered size="small"
                 :pagination="false">
          <template slot="amount" slot-scope="text, record">
            <a>{{ record.amount / 100 }}元</a>
          </template>
          <template slot="payType" slot-scope="text, record">
            <a>{{ payTypes[record.payType].name }}</a>
          </template>
        </a-table>
      </a-row>
    </template>
  </a-drawer>

</template>
<script>
import DescriptionItem from './DescriptionItem'

const orderColumns = [
  {    title: '订单编号',    dataIndex: 'orderId'  },
  {    title: '订单金额',    dataIndex: 'amount',    scopedSlots: {customRender: 'amount'},  },
  {    title: '支付方式',    dataIndex: 'payType'  ,scopedSlots: {customRender: 'payType'}},
];
const invoiceStates = {
  1: {    "code": 1,    "name": "待开票"  },
  2: {    "code": 2,    "name": "开票中"  },
  3: {    "code": 3,    "name": "已开票"  },
  4: {    "code": 4,    "name": "已拒绝"  },
  5: {    "code": 5,    "name": "已取消"  }
}
const payTypes = {
  1:{    'code': 1,    'name': '微信扫码'  },
  2: {    'code': 2,    'name': '支付宝扫码'  }
}
const payStates = {
  1: {    'code': 1,    'name':'未支付'  } ,
  2: {    'code':2,    'name':'支付成功'  }  ,
  3: {    'code':3,    'name': '部分退款'  }  ,
  4: {    'code': 4,    'name':'全额退款'  }  ,
  5: {    'code':5,    'name': '关闭支付'  }  ,
  6: {    'code': 6,    'name':'超时关闭'  }
}
const invoiceTypes = {
  1: {    "code": 1,    "name": "增值税专用发票"  },
  2: {    "code": 2,    "name": "增值税普通发票"  }
}
const buyerTypes = {
  1: {    "code": 1,    "name": "单位"  },
  2: {    "code": 2,    "name": "个人"  }
}
export default {
  name: "invoiceDetailsDrawer",
  components: {DescriptionItem},
  props: {
    invoice: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const pStyle = {
      fontSize: '16px',
      color: 'rgba(0,0,0,0.85)',
      lineHeight: '24px',
      display: 'block',
      marginBottom: '16px',
    };
    const pStyle2 = {
      marginBottom: '24px',
    };
    return {
      payStates,
      payTypes,
      invoiceStates,
      invoiceTypes,
      buyerTypes,
      pStyle,
      pStyle2,
      orderColumns
    }
  },
  methods: {

  },
  watch: {
    visible(val) {
      if (val){
      }
    }
  }
};
</script>
